@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faPlay"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'EXECUTE_MODAL.TITLE' | translate }}</h3>
          <p>{{ 'EXECUTE_MODAL.DESCRIPTION' | translate }}</p>
        </div>
      </div>
      <button class="close-btn" type="button" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="options-grid">

        @if (showFilesScope) {
        <div class="options-section">
          <div class="section-header">
            <span class="section-title">{{ 'EXECUTE_MODAL.FILES_SCOPE' | translate }}</span>
          </div>

          <div class="batch-axis-switch">
            <button type="button" [class.active]="runScope === 'all'" (click)="setRunScope('all')">
              {{ 'EXECUTE_MODAL.ALL_FILES' | translate }}
            </button>
            @if (archives.length > 0) {
            <button type="button" [class.active]="runScope === 'files'" (click)="setRunScope('files')">
              {{ 'EXECUTE_MODAL.SPECIFIC_FILES' | translate }}
            </button>
            }
            @if (fileGroups.length > 0) {
            <button type="button" [class.active]="runScope === 'groups'" (click)="setRunScope('groups')">
              {{ 'EXECUTE_MODAL.SPECIFIC_GROUPS' | translate }}
            </button>
            }
          </div>

          @if (runScope === 'files') {
          <div class="groups-select-field">
            <ng-select [items]="archives" bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false"
              [(ngModel)]="selectedFileIds" [placeholder]="'EXECUTE_MODAL.SELECT_FILES_PLACEHOLDER' | translate"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="true" [searchable]="true">
              <ng-template ng-option-tmp let-item="item">
                <span [title]="item.name">{{ item.name | truncateMiddle:40 }}</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span [title]="item.name">{{ item.name | truncateMiddle:25 }}</span>
              </ng-template>
            </ng-select>
          </div>
          }

          @if (runScope === 'groups') {
          <div class="groups-select-field">
            <ng-select [items]="fileGroups" bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false"
              [(ngModel)]="selectedGroupIds" [placeholder]="'EXECUTE_MODAL.SELECT_GROUPS_PLACEHOLDER' | translate"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="true" [searchable]="false">
              <ng-template ng-option-tmp let-item="item">
                <span class="group-option-dot" [style.background-color]="item.bg_color"></span>
                <span>{{ item.name }}</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="group-option-dot" [style.background-color]="item.bg_color"></span>
                <span>{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
          }
        </div>
        }

        @if (showConfigsSection) {
        <div class="options-section">
          <div class="section-header">
            <span class="section-title">
              {{ 'SETTINGS.PREFERENCES.DEFAULT_CONFIGS' | translate }}
            </span>

            <div class="section-header-actions">
              @if (canBatch) {
              <button class="batch-toggle-btn" [class.active]="batchMode" type="button" (click)="toggleBatchMode()">
                <fa-icon [icon]="batchMode ? faToggleOn : faToggleOff"></fa-icon>
                <span>{{ 'EXECUTE_MODAL.BATCH_MODE' | translate }}</span>
              </button>
              }
              <button *ngIf="isAdmin" class="benchmark-btn" type="button" (click)="openBenchmarkModal()">
                <fa-icon [icon]="infoIcon"></fa-icon>
                <span>{{ 'BENCHMARK.TITLE' | translate }}</span>
              </button>
            </div>
          </div>

          @if (batchMode) {
          <div class="batch-hint">
            <span>{{ 'EXECUTE_MODAL.BATCH_MODE_HINT' | translate }}</span>
            <div class="batch-axis-switch">
              <button type="button" [class.active]="batchAxis === 'delfos_llm_config_id'"
                (click)="setBatchAxis('delfos_llm_config_id')">
                {{ 'EXECUTE_MODAL.BATCH_AXIS_LLM' | translate }}
              </button>
              <button type="button" [class.active]="batchAxis === 'di2winocr_features_config_id'"
                (click)="setBatchAxis('di2winocr_features_config_id')">
                {{ 'EXECUTE_MODAL.BATCH_AXIS_OCR' | translate }}
              </button>
            </div>
          </div>
          }

          <div class="config-fields-group">
            @if (showDelfosServer) {
            <div class="config-field">
              <label>{{ 'SETTINGS.PREFERENCES.DELFOS_SERVER' | translate }}</label>
              <ng-select
                [items]="delfosServerConfigs"
                bindLabel="display_label"
                bindValue="id"
                [(ngModel)]="options.delfos_server_config_id"
                [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false">
              </ng-select>
            </div>
            }

            @if (showDelfosLlm) {
            <div class="config-field">
              <label>{{ 'SETTINGS.PREFERENCES.DELFOS_LLM' | translate }}</label>
              @if (batchMode && batchAxis === 'delfos_llm_config_id') {
              <ng-select
                [items]="delfosLlmConfigs"
                bindLabel="display_label"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="batchLlmIds"
                [placeholder]="'EXECUTE_MODAL.SELECT_MULTIPLE_PLACEHOLDER' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false">
                <ng-template ng-option-tmp let-item="item">
                  <div style="display:flex; justify-content:space-between; width:100%">
                    <span>{{ item.display_label }}</span>

                    <span>
                      @for (badge of getBadgesForModel(item.key); track badge) {
                        <span style="margin-left:4px">
                          <fa-icon [icon]="badgeIcons[badge]" class="benchmark-icon"></fa-icon>
                        </span>
                      }
                    </span>
                  </div>
                </ng-template>
              </ng-select>
              } @else {
              <ng-select
                [items]="delfosLlmConfigs"
                bindLabel="display_label"
                bindValue="id"
                [(ngModel)]="options.delfos_llm_config_id"
                [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false">
                <ng-template ng-option-tmp let-item="item">
                  <div style="display:flex; justify-content:space-between; width:100%">
                    <span>{{ item.display_label }}</span>

                    <span>
                      @for (badge of getBadgesForModel(item.key); track badge) {
                        <span style="margin-left:4px">
                          <fa-icon [icon]="badgeIcons[badge]" class="benchmark-icon"></fa-icon>
                        </span>
                      }
                    </span>
                  </div>
                </ng-template>
              </ng-select>
              }
            </div>
            }

            @if (showOcrServer) {
            <div class="config-field" [class.disabled]="options.use_multimodal">
              <label>{{ 'SETTINGS.PREFERENCES.OCR_SERVER' | translate }}</label>
              <ng-select
                [items]="di2winocrServerConfigs"
                bindLabel="display_label"
                bindValue="id"
                [(ngModel)]="options.di2winocr_server_config_id"
                [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false"
                [readonly]="options.use_multimodal">
              </ng-select>
            </div>
            }

            @if (showOcrFeatures) {
            <div class="config-field" [class.disabled]="options.use_multimodal">
              <label class="ocr-features-label">
                <span>{{ 'SETTINGS.PREFERENCES.OCR_FEATURES' | translate }}</span>
                @if (ocrOverride && canEditOcr) {
                <span class="ocr-custom-badge">{{ 'OCR_OVERRIDE.BADGE' | translate }}</span>
                }
              </label>
              @if (batchMode && batchAxis === 'di2winocr_features_config_id') {
              <ng-select
                [items]="di2winocrFeaturesConfigs"
                bindLabel="display_label"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="batchOcrFeatureIds"
                [placeholder]="'EXECUTE_MODAL.SELECT_MULTIPLE_PLACEHOLDER' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false"
                [readonly]="options.use_multimodal">
              </ng-select>
              } @else {
              <div class="ocr-features-row">
                <ng-select
                  class="ocr-features-select"
                  [items]="di2winocrFeaturesConfigs"
                  bindLabel="display_label"
                  bindValue="id"
                  [(ngModel)]="options.di2winocr_features_config_id"
                  (change)="onOcrSelectionChange()"
                  [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                  [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                  [clearable]="true"
                  [searchable]="false"
                  [readonly]="options.use_multimodal">
                </ng-select>
                <button type="button" class="ocr-gear-btn" [class.active]="ocrOverride && canEditOcr"
                  [disabled]="!canEditOcr" (click)="openOcrOverride()"
                  [title]="'OCR_OVERRIDE.EDIT_TOOLTIP' | translate">
                  <fa-icon [icon]="faGear"></fa-icon>
                </button>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }

        <div class="options-section secondary">
          <div class="section-header">
            <span class="section-title">{{ 'SETTINGS.PREFERENCES.CACHE_OPTIONS' | translate }}</span>
          </div>

          <div class="language-row">
            <div class="config-field language-field">
              <label>{{ 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE' | translate }}</label>
              <ng-select
                [items]="aiModelLanguageOptions"
                bindLabel="label"
                bindValue="value"
                [(ngModel)]="options.ai_model_language"
                [clearable]="false"
                [searchable]="false"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.label | translate }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.label | translate }}
                </ng-template>
              </ng-select>
            </div>

            @if (hasReferences) {
            <div class="config-field references-mode-field">
              <label>{{ 'SETTINGS.PREFERENCES.REFERENCES_MODE' | translate }}</label>
              <ng-select
                [items]="referencesModeOptions"
                bindLabel="label"
                bindValue="value"
                [(ngModel)]="options.references_mode"
                [clearable]="false"
                [searchable]="false"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.label | translate }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.label | translate }}
                </ng-template>
              </ng-select>
            </div>
            }
          </div>

          <div class="cache-toggle-grid">
            <div class="checkbox-item" [class.active]="options.clear_delfos_cache"
              (click)="toggleOption('clear_delfos_cache')">
              <div class="checkbox-control">
                <fa-icon [icon]="options.clear_delfos_cache ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'EXECUTE_MODAL.CLEAR_RESPONSE_CACHE' | translate }}</span>
            </div>

            <div class="checkbox-item" [class.active]="options.clear_di2winocr_cache"
              [class.disabled]="options.use_multimodal"
              (click)="!options.use_multimodal && toggleOption('clear_di2winocr_cache')">
              <div class="checkbox-control">
                <fa-icon [icon]="options.clear_di2winocr_cache ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'EXECUTE_MODAL.CLEAR_OCR_CACHE' | translate }}</span>
            </div>

            <div class="checkbox-item" [class.active]="options.use_multimodal"
              (click)="toggleOption('use_multimodal')">
              <div class="checkbox-control">
                <fa-icon [icon]="options.use_multimodal ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'EXECUTE_MODAL.USE_MULTIMODAL' | translate }}</span>
            </div>
          </div>

          @if (!batchMode) {
          <div class="save-preference-wrapper">
            <div class="checkbox-item save-as-default" [class.active]="options.save_as_default"
              (click)="toggleOption('save_as_default')">
              <div class="checkbox-control">
                <fa-icon [icon]="options.save_as_default ? faCheckSquare : faSquare"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'EXECUTE_MODAL.SAVE_AS_DEFAULT' | translate }}</span>
            </div>
          </div>
          }
        </div>

      </div>
    </div>

    <div class="modal-footer">
      <app-button [text]="'EXECUTE_MODAL.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
      </app-button>
      <app-button [text]="executeButtonLabel" variant="primary" [icon]="faPlay" [disabled]="isExecuteDisabled"
        (clicked)="onConfirm()">
      </app-button>
    </div>

    @if (isAdmin && showBenchmarkModal) {
      <div class="benchmark-modal-backdrop" (click)="closeBenchmarkModal(); $event.stopPropagation()">
        <div class="benchmark-modal" (click)="$event.stopPropagation()">
          <div class="benchmark-modal-header">
            <h4>
              <fa-icon [icon]="infoIcon"></fa-icon>
              {{ 'BENCHMARK.TITLE' | translate }}
            </h4>
            <button type="button" class="close-btn" (click)="closeBenchmarkModal()">
              <fa-icon [icon]="faTimes"></fa-icon>
            </button>
          </div>

          <div class="benchmark-modal-body">
            <div class="benchmark-summary">
              {{ benchmarkSummary }}
            </div>

            <div class="benchmark-list">
              @for (category of benchmarkCategories; track category.key) {
                <div class="benchmark-category">
                  <div class="benchmark-category-title">
                    <fa-icon [icon]="category.icon"></fa-icon>
                    <span class="category-title">{{ category.title | translate }}</span>
                    <span class="category-hint">{{ category.description | translate }}</span>
                  </div>
                  <div class="benchmark-models">
                    @for (model of category.models; track model.model) {
                      <div class="benchmark-model">
                        <span class="model-name">{{ model.model }}:</span>
                        <span class="model-metric">{{ model.metric }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          <div class="benchmark-modal-footer">
            <app-button [text]="'BUTTON.CLOSE' | translate" variant="secondary" (clicked)="closeBenchmarkModal()">
            </app-button>
          </div>
        </div>
      </div>
    }

    <app-modal-ocr-override
      [show]="showOcrOverride"
      [baseConfig]="selectedOcrConfig"
      [initialOverride]="ocrOverride"
      (apply)="onOverrideApply($event)"
      (restore)="onOverrideRestore()"
      (close)="onOverrideClose()">
    </app-modal-ocr-override>
  </div>
</div>
}
